import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AIRagChatModal } from "@src/components/organisms/modals/ai-rag-chat-modal/ai-rag-chat-modal";

export const AIRagChat = () => {
  const isAIRagChatOpen = useSelector(
    (state: RootState) => state.yourSlice.isAIRagChatOpen,
  );

  return <>{isAIRagChatOpen && <AIRagChatModal />}</>;
};
